<template>
	<v-row>
		<v-fade-transition mode="out-in">
			<result-revealer
				v-if="mode === modes.roulette"
				:result="result"
				:resources="{
					pick2Img: pick2,
					pick3Img: pick3,
					pick4Img: pick4,
					pick5Img: pick5
				}"
				@finish="handleResultsDone"
			>
				<template v-slot:logo>
					<v-img contain :src="logo">
					</v-img>
					 </template>
			</result-revealer>
			<winning-numbers
				v-else-if="mode === modes.winningNumbers"
				:result="result"
			></winning-numbers>
		</v-fade-transition>
	</v-row>
</template>

<script>
import WinningNumbers from "./WinningNumbers.vue";
import { Howl } from "howler";
import song from 'assets/static/sounds/piano_instrumental.mp3';
import ResultRevealer from '../../common/ResultRevealer.vue';
import logo from './images/logo-with-name.png';
import pick2 from './images/pick2.png';
import pick3 from './images/pick3.png';
import pick4 from './images/pick4.png';
import pick5 from './images/pick5.png';

const modes = {
	roulette: 1,
	winningNumbers: 2
};

export default {
	name: 'Roulette',
	props: {
		result: {
			type: Object,
			required: true
		}
	},
	created() {
		this.sound.play();
	},
	destroyed() {
		this.sound.stop();
	},
	components: {
		WinningNumbers,
		ResultRevealer
	},
	data() {
		return {
			logo,
			pick2,
			pick3,
			pick4,
			pick5,
			modes,
			mode: modes.roulette,
			sound: new Howl({
				src: song,
				duration: 4,
				autoplay: false,
				volume: 0.3,
				loop: true
			}) //,
			//mockedResult: {
			// 	numbers: [
			// 		{
			// 			playType: {
			// 				id: 4,
			// 				name: 'Pick 2'
			// 			},
			// 			digits: '23'
			// 		},
			// 		{
			// 			playType: {
			// 				id: 5,
			// 				name: 'Cash 3'
			// 			},
			// 			digits: '234'
			// 		},
			// 		{
			// 			playType: {
			// 				id: 6,
			// 				name: 'Play 4'
			// 			},
			// 			digits: '5678'
			// 		},
			// 		{
			// 			playType: {
			// 				id: 7,
			// 				name: 'Pick 5'
			// 			},
			// 			digits: '90123'
			// 		},
			// 	],
			// 	sortition: 'LUCKY LOTTO 12PM'
			// }
		};
	},
	methods: {
		handleResultsDone() {
			this.mode = modes.winningNumbers;

			setTimeout(() => {
				this.$root.$emit('sortition-time-done');
			}, 15000);
		}
	}
};
</script>
